import { SvgIconProps } from '@mui/material/SvgIcon';

import { SvgIcon } from './styled';

function MapPinnedIcon(props: SvgIconProps) {
  return (
    <SvgIcon width="17" height="16" viewBox="0 0 17 16" fill="none" {...props}>
      <path
        d="M8.33301 0C10.1011 6.31893e-08 11.7966 0.702883 13.0469 1.95312C14.297 3.20335 15 4.89896 15 6.66699C14.9999 9.26809 13.3438 11.5977 11.8174 13.209C11.0405 14.029 10.2652
        14.6957 9.68555 15.1572C9.39536 15.3883 9.15288 15.5695 8.98145 15.6934C8.89578 15.7552 8.82759 15.8032 8.78027 15.8359C8.75672 15.8522 8.73756 15.8643 8.72461 15.873C8.71839
        15.8773 8.71358 15.8814 8.70996 15.8838C8.7082 15.885 8.70616 15.886 8.70508 15.8867L8.7041 15.8877H8.70312L8.33301 15.334L8.70312 15.8887C8.47926 16.0378 8.18675 16.0378 7.96289
        15.8887L8.33301 15.334L7.96289 15.8877L7.96094 15.8867C7.95986 15.886 7.95782 15.885 7.95605 15.8838C7.95243 15.8814 7.94762 15.8773 7.94141 15.873C7.92846 15.8643 7.90929 15.8522
        7.88574 15.8359C7.83842 15.8032 7.77024 15.7552 7.68457 15.6934C7.51314 15.5695 7.27065 15.3883 6.98047 15.1572C6.40085 14.6957 5.62547 14.029 4.84863 13.209C3.3222 11.5977 1.66615
        9.26809 1.66602 6.66699C1.66602 4.89896 2.369 3.20335 3.61914 1.95312C4.86938 0.702882 6.5649 4.73534e-08 8.33301 0ZM8.33301 4.07617C7.05624 4.07617 6.02169 5.11098 6.02148 6.3877C6.02148
        7.66458 7.05612 8.7002 8.33301 8.7002C9.6099 8.7002 10.6455 7.66458 10.6455 6.3877C10.6453 5.11098 9.60977 4.07617 8.33301 4.07617Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default MapPinnedIcon;
